import { CloseDeleteDialog } from './typings'

export const closeDeleteDialogActionCreator = (): CloseDeleteDialog => ({
  type: 'activityTypes/closeDeleteDialog',
})
